import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar, NavbarItem, ISCLogo, LougoutButton } from "./styled.components";
import { ReactComponent as LogoImage } from "../../Assets/svg/CFAA_logo.svg";
import {
	UsergroupAddOutlined,
	SignalFilled
  } from '@ant-design/icons';
const Menu = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const handleLogout = () => {
		localStorage.removeItem("token");
		localStorage.removeItem("userName");
		localStorage.removeItem("role");
		navigate("/");
	};
	const getInitials = () => {
		if (
			localStorage.getItem("userName") &&
			localStorage.getItem("userName") !== null
		) {
			const fullName = localStorage.getItem("userName").split(" ");
			let initials = `${fullName.shift()?.charAt(0) || 'A'}${fullName.pop()?.charAt(0) || ''}`;
			return initials?.toUpperCase();
		} else {
			return "A";
		}
	};

	return (
		<Navbar selectedKeys={location.pathname}>
			<NavbarItem key="1" isdisabled="true">
				<Link to="/" style={{borderRight: '1px solid rgba(0,0,0,0.1)'}}>
					<LogoImage style={{ width: "100%", maxWidth: '200px' }} />
				</Link>
			</NavbarItem>
			{location.pathname === "/" ? (
				<></>
			) : (
				<>
					{location.pathname === "/final-user" ? (
						<NavbarItem key="/final-user" >
							<span><UsergroupAddOutlined /></span>
							<Link to="/final-user">Users</Link>
						</NavbarItem>
					) : location.pathname === "/admin" ? (
						<NavbarItem key="/admin">	
							<span><UsergroupAddOutlined /></span>
							<Link to="/admin">Users</Link>
						</NavbarItem>
					) : (
						<NavbarItem key="/super-admin" >
							<span><UsergroupAddOutlined /></span>
							<Link to="/super-admin">Users</Link>
						</NavbarItem>
					)}
					<NavbarItem key="/stats">
						<span><SignalFilled /> </span>
						<Link to="/stats">Stats</Link>
					</NavbarItem>
					<NavbarItem
						onClick={handleLogout}
						key="4"
						style={{ marginLeft: "auto", marginRight: "0px" }}
					>
						<LougoutButton>Logout</LougoutButton>
					</NavbarItem>
					<NavbarItem key="5" isdisabled="true">
						{/* <ISCLogo>{getInitials()}</ISCLogo> */}
						<p
							style={{
								display: "inline-flex",
								lineHeight: "25px",
								marginBottom: "0px",
								marginRight: "0px"
							}}
						>
							{/* {getName()} */}
						</p>
					</NavbarItem>
				</>
			)}
		</Navbar>
	);
};

export default Menu;
